<template>
  <div id="Login" class="login fullheight" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <div class="login__background-shape"></div>
    <CContainer fluid class="fullheight"> 
      <CRow class="align-start align-md-center fullheight">
        <CCol cols="12" md="12" :style="!is_finished ? 'margin-top: 30px !important' : 'margin-top: 100px !important'">
          <div class="login__container" style="max-width: 600px !important; margin: auto; padding: 30px 20px;">
            <div class="login__inner" style="max-width: 500px !important;" v-show="is_finished">
              <div class="login__image">
                <img src="main_logo.png" style="width: 160px; margin: 0 175px;" alt="Logo Oscuro"> <br><br> El proceso de recuperación de contraseña ha iniciado.<br><br>
                Hemos enviado un correo de recuperación de contraseña a tu cuenta de correo electrónico, en el cual podrás definir una nueva contraseña de acceso.
              </div>
              <div class="login__form">
                <CRow>
                  <CCol sm="12">
                    <br><CButton type="button" color="primary" style="width: 100%" @click="back">VOLVER</CButton>
                  </CCol>
                </CRow>
              </div>
            </div>
            <div class="login__inner" style="max-width: 500px !important" v-show="!is_finished">
              <div class="login__image">
                <img src="main_logo.png" style="width: 160px; margin: 0 175px;" alt="Logo Oscuro"> <br><br> Ingresa el Correo Electrónico de la cuenta que deseas recuperar su contraseña.<br><br>
              </div>
              <div class="login__form">
                <CRow>
                  <CCol sm="12">
                    <CInput
                        :isValid="checkIfValid('email')"
                        :value.sync="$v.form.email.$model"
                        label="Correo Electrónico"
                        placeholder=""
                        invalidFeedback="El RFC o Correo Electrónico es un campo obligatorio."
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <br />
                    <CButton type="button" color="primary" style="width: 250px; float: right;" :disabled="submitted" @click="recovery">{{ submitted ? 'ENVIANDO...' : 'RECUPERAR CONTRASEÑA' }}</CButton>
                    <CButton type="button" color="dark" style="width: 120px; float: left;" @click="back">CANCELAR</CButton>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <p v-if="feedbackMessage" :style="'margin-top: 12px; margin-bottom: 0; font-size: 12px; color: ' + (feedbackType == 'success' ? '#2e7d32' : '#b42318')">
                      {{ feedbackMessage }}
                    </p>
                  </CCol>
                </CRow>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>

import router from '../../../router/index'
import login from '../../../services/login';
import store from '../../../store'

import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"

export default {
    name: 'ForgetForm',
    components: {

    },
    data () {
        return {
            is_finished: false,
            form: {
              email: ''
            },
            submitted: false,
            feedbackType: '',
            feedbackMessage: '',
        }
    },
    mounted: async function() {
      
    },
    methods: {
        async recovery () {
            this.feedbackType = '';
            this.feedbackMessage = '';
            this.$v.$touch();
            if(this.$v.form.$invalid){
              this.feedbackType = 'error';
              this.feedbackMessage = 'Ingresa tu correo electrónico para recuperar tu contraseña.';
              return;
            }

            this.submitted = true;
            this.loading();

            try {
              let response = await login.recoveryAccount({
                email: (this.form.email || '').trim().toLowerCase()
              });
              
              if(response.type == "success"){
                this.feedbackType = 'success';
                this.feedbackMessage = 'Te enviamos un correo con instrucciones para recuperar tu contraseña.';
                this.is_finished = true;
              }
              else{
                this.feedbackType = 'error';
                this.feedbackMessage = response.message || 'No fue posible procesar la solicitud.';
                this.showToast('warning', response.message || 'No fue posible procesar la solicitud.');
              }
            } catch (error) {
              const message = error && error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No fue posible conectar con el servidor.';
              this.feedbackType = 'error';
              this.feedbackMessage = message;
              this.showToast('danger', message);
            } finally {
              this.submitted = false;
              this.loaded();
            }
        },
        back(){
          router.push("login");
        },
        checkIfValid (fieldName) {
            const field = this.$v.form[fieldName]
            if (!field.$dirty) {
                return null
            }
            
            return !(field.$invalid)
        },
        showToast(type, message){
            store.commit('toast', {color: type, message: message});
        },
        loading(){
            store.commit('loading');
        },
        loaded(){
            store.commit('loaded');
        }
    },
    computed: {
        formString () { return JSON.stringify(this.form, null, 4) },
        isValid () { return !this.$v.form.$invalid },
        isDirty () { return this.$v.form.$anyDirty },
    },
    mixins: [validationMixin],
    validations: {
        form: {
            email: {
                required
            }
        }
    },
}
</script>

<style scoped>
.login__background-shape {
  position: absolute;
  top: -120px;
  right: -90px;
  width: 280px;
  height: 280px;
  border-radius: 999px;
  background: radial-gradient(circle at 35% 35%, rgba(22, 108, 181, 0.22), rgba(22, 108, 181, 0));
  pointer-events: none;
}
</style>